import React from 'react';

const Loading = props => {
  return (
    <div className='broad'>Loading...</div>
  )
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/widgets/Loading.js